export default {
  SET_HANDOVER_REPORTS_LOADING: Symbol('SET_HANDOVER_REPORTS_LOADING'),
  INIT_HANDOVER_REPORTS: Symbol('INIT_HANDOVER_REPORTS'),
  INIT_AMOUNT_LIST: Symbol('INIT_AMOUNT_LIST'),
  RESET_HANDOVER_REPORTS: Symbol('RESET_HANDOVER_REPORTS'),
  SET_DUTY_LIST_LOADING: Symbol('SET_DUTY_LIST_LOADING'),
  INIT_DUTY_LIST: Symbol('INIT_DUTY_LIST'),
  UPDATE_REPORT_STATE: Symbol('UPDATE_REPORT_STATE'),
  REPORT_BAS_BUSINESS: Symbol('REPORT_BAS_BUSINESS'),
  REPORT_RECEPTION: Symbol('REPORT_RECEPTION'),
  REPORT_CARD: Symbol('REPORT_CARD'),
  REPORT_BALANCE: Symbol('REPORT_BALANCE'),
  MEMBER_CARD_DETAIL: Symbol('MEMBER_CARD_DETAIL'),
  // REPORT_MEMBER_CARD: Symbol('REPORT_MEMBER_CARD'),
  SET_CROSS_NA_REFUND_LIST_LOADING: Symbol('SET_CROSS_NA_REFUND_LIST_LOADING'),
  INIT_CROSS_NA_REFUND_LIST: Symbol('INIT_CROSS_NA_REFUND_LIST'),
  SET_CROSS_NA_REFUND_LIST_TOTAL: Symbol('SET_CROSS_NA_REFUND_LIST_TOTAL'),
  UPDATE_CROSS_NA_REFUND_LIST: Symbol('UPDATE_CROSS_NA_REFUND_LIST'),
};
